import SuperAdmin from "../utils/Protected/SuperAdmin"
import Dashboard from "../pages/Admin/Dashboard"
import { Route } from "react-router-dom"
import Layout from "../layouts/admin"

// FAQs routes
import AddFaqs from "../pages/Admin/FAQs/AddFaqs"
import AllFaqs from "../pages/Admin/FAQs/AllFaqs"

// Blogs routes
import BlogCategories from "../pages/Admin/Blogs/Categories"
import AllBlogs from "../pages/Admin/Blogs/AllBlogs"
import EditBlog from "../pages/Admin/Blogs/EditBlog"
import AddBlog from "../pages/Admin/Blogs/AddBlog"

// Forum routes
import ForumCategories from "../pages/Admin/Forum/Categories"
import AllForum from "../pages/Admin/Forum/AllForum"

// Specialists routes
import AllSpecialists from "../pages/Admin/Specialists/AllSpecialists"
import Details from "../pages/Admin/Specialists/Details"
import Members from "../pages/Admin/Specialists/Details/Members"
import Appointments from "../pages/Admin/Specialists/Details/Appointments"
import SpecialistDetailLayout from "../pages/Admin/Specialists/Details/SpecialistDetailLayout"
import SpecialistWallet from "../pages/Admin/Specialists/Details/Wallet"

//Members route
import AllMembers from "../pages/Admin/Members/AllMembers"
import MemberLayout from "../pages/Admin/Members/Details"
import MemberDetails from "../pages/Admin/Members/Details/Details"
import MembersSpecialists  from "../pages/Admin/Members/Details/Specialists"
import MembersAppointments  from "../pages/Admin/Members/Details/Appointments"

//Appointments
import AllAppointments from "../pages/Admin/Appointment"
// Webinars routes
import SingleWebinar from "../pages/Admin/Webinars/single"
import AllWebinars from "../pages/Admin/Webinars/list"

// Payments routes
import AllPayments from "../pages/Admin/Payments/AllPayments"

// Wallet routes
import WalletOverview    from "../pages/Admin/Wallet/Overview"
import WalletSpecialists from "../pages/Admin/Wallet/Specialists"
import WalletPayouts     from "../pages/Admin/Wallet/Payouts"
import WalletRisk        from "../pages/Admin/Wallet/Risk"

// Settings route
import Settings          from "../pages/Admin/Settings"

const AdminRoutes = (
  <Route path="/" element={<Layout />}>
    <Route path="dashboard" element={<SuperAdmin><Dashboard /></SuperAdmin>} />

    {/* FAQs routes */}
    <Route path="faqs/all" element={<SuperAdmin><AllFaqs /></SuperAdmin>} />
    <Route path="faqs/add" element={<SuperAdmin><AddFaqs /></SuperAdmin>} />
    <Route path="faqs/edit/:faqId" element={<SuperAdmin><AddFaqs /></SuperAdmin>} />

    {/* Blogs routes */}
    <Route path="blogs/add" element={<SuperAdmin><AddBlog /></SuperAdmin>} />
    <Route path="blogs/all" element={<SuperAdmin><AllBlogs /></SuperAdmin>} />
    <Route path="blogs/edit/:blogId" element={<SuperAdmin><EditBlog /></SuperAdmin>} />
    <Route path="blogs/categories" element={<SuperAdmin><BlogCategories /></SuperAdmin>} />

    {/* Forum routes */}
    <Route path="forum/all" element={<SuperAdmin><AllForum /></SuperAdmin>} />
    <Route path="forum/categories" element={<SuperAdmin><ForumCategories /></SuperAdmin>} />

    {/* Specialists routes */}
    <Route path="specialists/all" element={<SuperAdmin><AllSpecialists /></SuperAdmin>} />
    <Route path="specialist/detail/:userId" element={<SuperAdmin><SpecialistDetailLayout /></SuperAdmin>}>
      <Route index element={<Details />} />
      <Route path="members" element={<Members />} />
      <Route path="appointments" element={<Appointments />} />
      <Route path="wallet" element={<SpecialistWallet />} />
    </Route>

    {/* Members routes */}
    <Route path="members/all" element={<SuperAdmin><AllMembers /></SuperAdmin>} />
    <Route path="member/details/:userId" element={<SuperAdmin><MemberLayout /></SuperAdmin>}>
      <Route index element={<MemberDetails />} />
      <Route path="specialists" element={<MembersSpecialists />} />
      <Route path="appointments" element={<MembersAppointments />} />
    </Route>

    {/* All appointments */}
    <Route path="appointments/all" element={<SuperAdmin><AllAppointments /></SuperAdmin>} />

    {/* Webinars routes */}
    <Route path="webinar/:type" element={<SuperAdmin><AllWebinars /></SuperAdmin>} />
    <Route path="webinar/view/:id" element={<SuperAdmin><SingleWebinar /></SuperAdmin>} />

    {/* Payments routes */}
    <Route path="payments/all" element={<SuperAdmin><AllPayments /></SuperAdmin>} />

    {/* Wallet / Escrow routes */}
    <Route path="wallet/overview"    element={<SuperAdmin><WalletOverview /></SuperAdmin>} />
    <Route path="wallet/specialists" element={<SuperAdmin><WalletSpecialists /></SuperAdmin>} />
    <Route path="wallet/payouts"     element={<SuperAdmin><WalletPayouts /></SuperAdmin>} />
    <Route path="wallet/risk"        element={<SuperAdmin><WalletRisk /></SuperAdmin>} />

    {/* Settings route */}
    <Route path="settings"           element={<SuperAdmin><Settings /></SuperAdmin>} />
  </Route>
)

export default AdminRoutes